export const readEmpty = async (skip,user) => {
    try{
        const res = await fetch( 
            `${process.env.REACT_APP_BACKEND_URL}/listInquiryNewEmpty?skip=${skip}&user=${user}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
        return await res.json();
    } catch(error){
        throw new Error(error);
    }
}